import React, { Component } from 'react';
import LayoutPages from '../../Components/LayoutPages';
import FiltrosCorrida from '../../Components/FiltrosCorrida/FiltrosCorrida.js';
import {
    List,
    Card,
    Row,
    Col,
    DatePicker,
    Button,
    Modal,
    Divider,
    TimePicker,
    Spin,
} from 'antd';
import UserProvider from '../../js/userProvider';
import DataService from '../../Components/Data';
import InfiniteScroll from 'react-infinite-scroller';
import './HistoricoPA.css';
import moment from 'moment';

const dateFormat = 'DD/MM/YYYY';
const hourFormat = 'HH:mm';

const corrida = {
    CdTerminalAtividade: "",
    DsPrefixoM: "",
    HrAtividade: "",
    NrLatitude: "",
    NrLongitude: "",
    NrVelocidade: "",
    StSelecionado: false
}

class HistoricoPA extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
            modalFiltroVisible: false,
            corridaSelecionada: corrida,
            openHoraInicio: false,
            openHoraFim: false,
            listData: [],
            loadingData: false,
            lat: null,
            lng: null,
            checkedKeys: [],
            horaInicio: "00:00",
            horaFim: "23:00",
            hasMore: true,
            loadingInfinite: false,            
            markers: [],
            dataSelecionada: moment(),
            nrLinhaRastreioSelecionada: -1
        }

        this.inicial = 0;
        this.final = 10;

        this.dataService = new DataService();
        this.dadosProvider = UserProvider.getInstance();
        this.usuario = this.dadosProvider.getDadosUsuario();
    };

    handleInfiniteOnLoad = () => {
        console.log("infinite");
        this.loadItens(false);
    }

    componentWillMount() {

        navigator.geolocation.getCurrentPosition(
            position => {
                this.setState({ lat: position.coords.latitude, lng: position.coords.longitude });
            },
            error => console.log(error)
        );

        document.addEventListener("keydown", this.onKeyDown, false);
    }

    componentWillUnmount(){
        document.removeEventListener("keydown", this.onKeyDown, false);
    }

    onKeyDown = (event)=>{
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                document.getElementById("tbHistoricoPA").focus();
                
                this.navegarPraBaixo();

                break;
            case "ArrowUp":
                event.preventDefault();
                document.getElementById("tbHistoricoPA").focus();
                this.navegarPraCima();
                break;
        }
    }

    navegarPraBaixo(){
        var lista = this.state.listData;
        
        if(lista.length == 0)
            return;

        var novaLinhaSelecionada = this.state.nrLinhaRastreioSelecionada;        

        if(this.state.nrLinhaRastreioSelecionada == -1){
            novaLinhaSelecionada = 0;
        }else{
            lista[this.state.nrLinhaRastreioSelecionada].StSelecionado = false;

            var novaLinha = this.state.nrLinhaRastreioSelecionada+1;

            if(novaLinha < this.state.listData.length)
                novaLinhaSelecionada = novaLinha;
        }

        lista[novaLinhaSelecionada].StSelecionado = true;

        var listItem = document.querySelectorAll("#tbHistoricoPA .ant-list-item")[novaLinhaSelecionada];
        listItem.scrollIntoViewIfNeeded();

        this.setState({
            listData: lista,
            nrLinhaRastreioSelecionada: novaLinhaSelecionada
        });
    }

    navegarPraCima(){
        var lista = this.state.listData;

        if(lista.length == 0)
            return;

        var novaLinhaSelecionada = this.state.nrLinhaRastreioSelecionada;        

        if(this.state.nrLinhaRastreioSelecionada == -1){
            novaLinhaSelecionada = 0;
        }else{
            lista[this.state.nrLinhaRastreioSelecionada].StSelecionado = false;

            var novaLinha = this.state.nrLinhaRastreioSelecionada-1;

            if(novaLinha > -1)
                novaLinhaSelecionada = novaLinha;
        }

        lista[novaLinhaSelecionada].StSelecionado = true;

        var listItem = document.querySelectorAll("#tbHistoricoPA .ant-list-item")[novaLinhaSelecionada];
        listItem.scrollIntoViewIfNeeded();

        this.setState({
            listData: lista,
            nrLinhaRastreioSelecionada: novaLinhaSelecionada
        });
    }

    handleOpenHoraInicio = (open) => {
        this.setState({ openHoraInicio: open });
    }

    handleOpenHoraFim = (open) => {
        this.setState({ openHoraFim: open });
    }

    handleCloseHoraInicio = (value) => {
        console.log(value);
        this.setState({ openHoraInicio: false });
    }
    handleCloseHoraFim = () => this.setState({ openHoraFim: false })

    handleClickLink = (selecionada) => {
        if(this.state.nrLinhaRastreioSelecionada > -1){
            this.state.listData[this.state.nrLinhaRastreioSelecionada].StSelecionado = false;
            this.state.nrLinhaRastreioSelecionada = -1;
        }            
    };

    showModal = () => {
        this.setState({
            modalVisible: true,
        });
    }

    handleCancel = (e) => {
        console.log(e);
        this.setState({
            modalVisible: false,
        });
    }

    showModalFiltro = () => {
        this.setState({
            modalFiltroVisible: true,
        });
    }

    handleFiltroCancel = (e) => {
        console.log(e);
        this.setState({
            modalFiltroVisible: false,
        });
    }

    onSelectData = (value) => {
        this.setState({ dataSelecionada: value });
    }

    loadItens(nova) {

        this.setState({
            loadingInfinite: true
        });

        var veiculo = "";
        var motoristas = "";

        for (var i in this.state.checkedKeys) {
            var chave = this.state.checkedKeys[i];

            if (chave.charAt(0) == "V") {
                veiculo = chave.substr(1);
            } else {
                motoristas += chave.substr(1) + ",";
            }
        }

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        if (veiculo == "" && motoristas == "") {
            veiculo = usuario.UiPessoa;
            motoristas = usuario.UiPessoa;
        }

        var dados = {
            "uiFilial": filial,
            "uiPessoaVeiculo": veiculo,
            "uiPessoaMotorista": motoristas,
            "dtAtividade": `${this.state.dataSelecionada.format("DD/MM/YYYY")}`,
            "hrInicial": this.state.horaInicio,
            "hrFinal": this.state.horaFim,
            "nrInicial": this.inicial,
            "nrFinal": this.final
        };

        this.dataService.GetListaHistoricoPA(dados, (retorno) => {

            if (nova) {
                var newData = [];
            } else {
                var newData = this.state.listData;
            }

            if (retorno.length > 0) {
                for (var i in retorno) {
                    var dado = retorno[i];

                    newData.push({
                        CdTerminalFilaHistorico: dado['CdTerminalFilaHistorico'],
                        DsPrefixoM: dado['DsPrefixoM'],
                        HrAtividade: dado['HrAtividade'],
                        NrPosicao: dado['NrPosicao'],
                        DsPA: dado['DsPA'],
                        DsObs: dado['DsObs'],
                        StSelecionado: false
                    });
                }
            }

            this.inicial = this.final;
            this.final = this.final + 10;

            this.setState({
                loadingInfinite: false,
                listData: newData
            });

        }, (erro) => {
            console.log(erro)
            this.setState({ loadingInfinite: false});
        });
    }

    handleFiltroOk = () => {
      
        this.inicial = 0;
        this.final = 10;

        this.setState({
            modalFiltroVisible: false
        });

        this.loadItens(true);
    }

    onChangeInicio = (time) => {
        console.log(time.format("HH:mm"));
        this.setState({ horaInicio: time.format("HH:mm") });
    }

    onChangeFim = (time) => {
        console.log(time.format("HH:mm"));
        this.setState({ horaFim: time.format("HH:mm") });
    }

    onCheckKey(checkedKeys) {

        this.setState({ checkedKeys });
    }



    render() {

        const header = (
            <Card className="hidden-sm">
                <Row gutter={6}>
                    <Col xs={0} sm={0} md={4} lg={4} xl={4}>
                        <strong>Prefixo</strong>
                    </Col>
                    <Col xs={0} sm={0} md={4} lg={4} xl={4}>
                        <strong>Horário</strong>
                    </Col>
                    <Col xs={0} sm={0} md={4} lg={4} xl={4}>
                        <strong>Posição</strong>
                    </Col>
                    <Col xs={0} sm={0} md={4} lg={4} xl={4}>
                        <strong>PA</strong>
                    </Col>
                    <Col xs={0} sm={0} md={8} lg={8} xl={8}>
                        <strong>Observação</strong>
                    </Col>
                </Row>
            </Card>
        );

        const date = moment();


        return (
            <LayoutPages pageTitle="Histórico de PA" history={this.props.history} pageIndex="3">
                <div className="historicoPA">

                    <Modal
                        title="Filtros"
                        visible={this.state.modalFiltroVisible}
                        onCancel={this.handleFiltroCancel}
                        onOk={this.handleFiltroOk}
                    >
                        {this.state.modalFiltroVisible ? (
                            <FiltrosCorrida onCheckKey={this.onCheckKey.bind(this)} checkedKeys={this.state.checkedKeys} />
                        ) : ""}
                    </Modal>

                    <div>
                        <Divider orientation="left">Filtros</Divider>

                        <Row gutter={6}>
                            <Col xs={12} sm={6} md={5} lg={3} xl={3}>
                                Data:
                                <DatePicker defaultValue={moment()} style={{ width: '100%' }} format={dateFormat} onChange={this.onSelectData} />
                            </Col>
                            <Col xs={12} sm={6} md={5} lg={3} xl={3}>
                                Horário inicial:
                                <TimePicker
                                    style={{ width: '100%' }}
                                    open={this.state.openHoraInicio}
                                    onOpenChange={this.handleOpenHoraInicio}
                                    inputReadOnly={true}
                                    onChange={this.onChangeInicio}
                                    addon={() => (
                                        <Button size="small" type="primary" onClick={this.handleCloseHoraInicio}>
                                            Ok
                                        </Button>
                                    )}
                                    defaultValue={moment('00:00', hourFormat)} format={hourFormat} />
                            </Col>
                            <Col xs={12} sm={6} md={5} lg={3} xl={3}>
                                Horário final:
                                <TimePicker
                                    style={{ width: '100%' }}
                                    open={this.state.openHoraFim}
                                    onOpenChange={this.handleOpenHoraFim}
                                    inputReadOnly={true}
                                    onChange={this.onChangeFim}
                                    addon={() => (
                                        <Button size="small" type="primary" onClick={this.handleCloseHoraFim}>
                                            Ok
                                </Button>
                                    )}
                                    defaultValue={moment('23:59', hourFormat)} format={hourFormat} />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3} xl={3}>
                                <br />
                                <Button
                                    icon="bars"
                                    onClick={() => this.showModalFiltro()}
                                    style={{ backgroundColor: '#b9b9b9', color: '#fff', width: '100%' }}>Filtros</Button>
                            </Col>
                            <Col xs={24} sm={24} md={5} lg={3} xl={3}>
                                <br />
                                <Button type="primary" style={{ width: '100%' }} onClick={this.handleFiltroOk} icon="search">Filtrar</Button>
                            </Col>
                        </Row>

                        <Divider />
                    </div>

                    <Row>
                        <div id="tbHistoricoPA" className="infinite-container">
                            <InfiniteScroll
                                initialLoad={false}
                                pageStart={0}
                                loadMore={this.handleInfiniteOnLoad}
                                hasMore={!this.state.loadingInfinite && this.state.hasMore}
                                useWindow={false}
                            >
                                <List
                                    itemLayout="vertical"
                                    size="large"
                                    header={header}
                                    dataSource={this.state.listData}
                                    className="tbHistoricoPA"
                                    renderItem={item => (
                                        <List.Item onClick={() => this.handleClickLink(item)} key={item.id}>

                                            <Card className={item.StSelecionado ? "rastreio--selecionado" : ""}>
                                                <Row gutter={6}>
                                                    <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                        <strong className="hidden-md">Prefixo:</strong> {item.DsPrefixoM}
                                                    </Col>
                                                    <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                        <strong className="hidden-md">Horário:</strong> {item.HrAtividade}
                                                    </Col>
                                                    <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                        <strong className="hidden-md">Posição:</strong> {item.NrPosicao}
                                                    </Col>
                                                    <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                        <strong className="hidden-md">PA:</strong> {item.DsPA}
                                                    </Col>
                                                    <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                        <strong className="hidden-md">Observação:</strong> {item.DsObs}
                                                    </Col>
                                                </Row>

                                            </Card>

                                        </List.Item>
                                    )}
                                />

                                {this.state.loading && this.state.hasMore && (
                                    <div className="demo-loading-container">
                                        <Spin />
                                    </div>
                                )}
                            </InfiniteScroll>
                        </div>
                    </Row>


                </div>
            </LayoutPages>
        )
    }
}

export default HistoricoPA;


// WEBPACK FOOTER //
// ./src/Pages/HistoricoPA/HistoricoPA.js